import { randomNum } from '@klinx/utils';
import db from '@klinx/utils/localstorage';
const state = {
  activeStep: 1,
  // 步骤一中选中的数据.总未开卡匹数，这里先写死
  orderInfo: {
    businessId: "",
    businessName: "",
    contractNumber: "",
    createTime: "",
    createdBy: "",
    customer: "",
    customerGroupId: "",
    customerGroupName: "",
    customerId: "",
    customerOrderNumber: "",
    customerStyleNumber: "",
    deliverDate: "",
    erpCreateName: "",
    erpCreateTime: "",
    id: "",
    invoiceType: "",
    isDelete: "",
    isExpedited: "",
    number: "",
    orderDate: "",
    orderType: "",
    orderTyping: "",
    orgId: "",
    orgName: "",
    remark: "",
    shippingAddress: "",
    source: "0",
    updateTime: "",
    updatedBy: "",
    userId: "",
    userName: "",
    _XID: "",
    // 总未开卡匹数
    notOpenCardCount: 0
  },
  // 步骤二中选中的数据
  checkboxList: [],
  step2TableRef: null,
  uuid: randomNum(32),
  // 加工要求的表
  processRequireList: [],
  // 生成的批次Id
  batchId: '',
  stepOneForm: db.get('batchAdd')?.stepOneForm || null,
  stepSecondForm: db.get('batchAdd')?.stepSecondForm || null,
  saveLocalTimerInfo: db.get('batchAdd')?.saveLocalTimerInfo || null
};
const mutations = {
  activeStepAdd(state) {
    state.activeStep < 4 && state.activeStep++;
  },
  setActiveStep(state, data) {
    state.activeStep = data;
  },
  activeStepReduce(state) {
    state.activeStep--;
  },
  activeStepTo3(state) {
    state.activeStep = 3;
  },
  activeStepTo1(state) {
    state.activeStep = 1;
  },
  setOrderInfo(state, data) {
    state.orderInfo = data || {};
  },
  setCheckboxList(state, data) {
    state.checkboxList = data;
  },
  setStep2TableRef(state, data) {
    state.step2TableRef = data;
  },
  resetUuid(state) {
    state.uuid = randomNum(32);
  },
  setProcessRequireList(state, data) {
    state.processRequireList = data;
  },
  setBatchId(state, data) {
    state.batchId = data;
  },
  resetBatchVuex(state) {
    // 以上直接赋值不行
    state.activeStep = 1;
    state.orderInfo = {
      businessId: "",
      businessName: "",
      contractNumber: "",
      createTime: "",
      createdBy: "",
      customer: "",
      customerGroupId: "",
      customerGroupName: "",
      customerId: "",
      customerOrderNumber: "",
      customerStyleNumber: "",
      deliverDate: "",
      erpCreateName: "",
      erpCreateTime: "",
      id: "",
      invoiceType: "",
      isDelete: "",
      isExpedited: "",
      number: "",
      orderDate: "",
      orderType: "",
      orderTyping: "",
      orgId: "",
      orgName: "",
      remark: "",
      shippingAddress: "",
      source: "0",
      updateTime: "",
      updatedBy: "",
      userId: "",
      userName: "",
      _XID: "",
      // 总未开卡匹数
      notOpenCardCount: 0
    };
    state.checkboxList = [];
    state.step2TableRef = null;
    state.uuid = randomNum(32);
    state.processRequireList = [];
    state.batchId = '';
    state.saveLocalTimerInfo = null;
    state.stepOneForm = null;
    state.stepSecondForm = null;
  },
  setSaveLocalTimerInfo(state, data) {
    state.saveLocalTimerInfo = data;
    db.save('batchAdd', state);
  },
  resetSaveLocalTimerInfo(state) {
    state.saveLocalTimerInfo = null;
    db.save('batchAdd', state);
  },
  setStepOneForm(state, data) {
    state.stepOneForm = data;
    db.save('batchAdd', state);
  },
  setStepSecondForm(state, data) {
    state.stepSecondForm = data;
    db.save('batchAdd', state);
  },
  resetStepSecondForm(state) {
    state.stepSecondForm = null;
  }
};
export default {
  namespaced: true,
  state,
  mutations
};
